module.exports = __webpack_public_path__ + "AQ_Persona_Launch_MyAquent_576x756_v1.png";